import { api } from '@/lib/api'

/** @typedef {import('@/types/api').Stylist} Stylist */
/** @typedef {import('@/types/api').DiscountReason} DiscountReason */

/**
 * @typedef {object} PosCustomerSnapshot
 * @property {number} customer_id
 * @property {string} name
 * @property {string | null} phone
 * @property {string | null} membership_tier
 * @property {number} package_count
 * @property {number | null} points
 * @property {string} outstanding_balance
 * @property {string | null} last_visit_at
 * @property {string | null} last_visit_sale_number
 * @property {Array<{ id: number, sale_number: string, completed_at: string | null, total: string }>} recent_visits
 */

/**
 * @returns {Promise<Stylist[]>}
 */
export async function fetchPosStylists() {
  const { data } = await api.get('/pos/stylists')
  return data.data.stylists
}

/**
 * @returns {Promise<DiscountReason[]>}
 */
export async function fetchPosDiscountReasons() {
  const { data } = await api.get('/pos/discount-reasons')
  return data.data.discount_reasons
}

/**
 * @param {number} customerId
 * @returns {Promise<PosCustomerSnapshot>}
 */
export async function fetchCustomerSnapshot(customerId) {
  const { data } = await api.get(`/pos/customers/${customerId}/snapshot`)
  return data.data.snapshot
}

/**
 * @param {string} query
 * @param {number} [limit]
 * @returns {Promise<import('@/types/api').Service[]>}
 */
export async function searchPosServices(query, limit = 40) {
  const { data } = await api.get('/services/search', {
    params: { q: query, limit },
  })
  return data.data.services
}
